import { jwtDecode } from "jwt-decode";

export function isValidToken(token) {
  return true;
  if (!token) {
    return false; 
  }
  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    if (decodedToken.exp && decodedToken.exp < currentTime) {
      return false;
    }
    return true;
  } catch (error) {
    console.log(error)
    return false;
  }
}